import React from 'react';

const GroupItem = (params) => {  
    return (
        <div className="card" style={{ maxWidth: "750px" }}>
            <h5 className="card-header py-3">
                <i className="fa fa-folder-open-o" aria-hidden="true"></i> Group History
            </h5>
            <div className="card-body">
                <div className="ag-theme-alpine">
                    <div style={{ backgroundColor: 'white', marginBottom:"15px" }}>
                        <div className="row">
                            <div className="col-md-6">
                                <b>Group Name:</b> {params.data.groupName} [{params.data.actionName}]
                            </div>
                            <div className="col-md-3">
                                <b>Modified By:</b> {params.data.modifiedBy}
                            </div>                        
                            <div className="col-md-3">
                                <b>Modified Date:</b> {params.data.actionDateTime}
                            </div>
                        </div>
                    </div>
                    <div style={{ borderRadius: "10px", padding: "10px", backgroundColor: "#EFEFEF", maxHeight: "300px", overflowY: 'auto' }} dangerouslySetInnerHTML={{ __html: params.data.details }}></div>
                </div>
            </div>
            <div className="card-footer text-muted">
                <div style={{ textAlign: "center" }}>
                    <button className="btn btn-secondary" onClick={params.onClose}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default GroupItem;